export default {};
export const ReadStream = {};
export const WriteStream = {};
export const isatty = () => undefined;